// extracted by mini-css-extract-plugin
module.exports = {"badge":"LineupCamBadge_badge__p_GkO"};